import { ReactNode } from 'react'
import { useIsExternalUser } from '@/hooks/useIsExternalUser'
import { Navigate, useParams } from 'react-router-dom'

/**
 * Redirects external users (accessing the host org via an
 * ExternalOrgRelationship) away from member-only personal routes such as
 * /my-time and /my-expenses.
 *
 * Direct members render children unchanged.
 */
export function RequireMemberAccess({ children }: { children: ReactNode }) {
  const isExternalUser = useIsExternalUser()
  const { orgSlug } = useParams<{ orgSlug: string }>()

  if (isExternalUser) {
    return (
      <Navigate to={orgSlug ? `/${orgSlug}/today` : '/organizations'} replace />
    )
  }

  return <>{children}</>
}
